import dayjs from 'dayjs';
import 'dayjs/locale/ro';
import customFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Imported by both App.tsx and vitest.setup.ts: without utc + timezone, formatDateTime throws rather than shifting.
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(customFormat);
dayjs.extend(relativeTime);
